export const portfolioData = {
  profile: {
    name: "Harshita Priya",
    location: "Bokaro, India",
    basedIn: "Bengaluru, India",
    title: "Software Developer (Full Stack)",
    tagline: "Building reliable product flows across web, mobile, and APIs.",
    summary:
      "I am a full stack engineer focused on turning product requirements into stable, user-facing features. My recent work spans Angular and Flutter frontends, Node.js and Express APIs, authentication flows, and performance-minded frontend architecture.",
    about:
      "I enjoy working across the stack when the product needs it, especially where a feature has to stay consistent between web and mobile. I care about maintainable code, fewer regressions, and clean handoffs for the next iteration.",
    email: "harshita.priya.dev@gmail.com",
    github: "https://github.com/harshita-priya1",
    linkedin: "https://www.linkedin.com/in/harshita-priya-192955212/",
    portfolioRepo: "https://github.com/harshita-priya1/new-portfolio",
  },
  typewriterRoles: [
    "Software Developer",
    "Full Stack Developer",
    "Angular, React, Flutter Engineer",
  ],
  heroStats: [
    {
      label: "Current focus",
      value: "Web and mobile parity",
    },
    {
      label: "Core stack",
      value: "Angular, Flutter, Node.js",
    },
    {
      label: "Education",
      value: "BIT Mesra, 8.84 CGPA",
    },
  ],
  specialties: [
    "Full stack product development",
    "Angular, React, and Flutter interfaces",
    "Node.js, Express, and REST APIs",
    "Authentication and app integration flows",
    "Performance, testing, and maintainability",
  ],
  experience: [
    {
      title: "Software Development Engineer (Full Stack)",
      company: "Cashvisory",
      location: "Bengaluru, India",
      period: "Jan 2024 - Present",
      bullets: [
        "Built a self-serve Book a Call flow across Angular, Node.js/Express APIs, and Calendly integrations to replace manual scheduling.",
        "Led web-to-mobile parity across Angular and Flutter for order placement, payments, order details, and financial graphs.",
        "Rebuilt the Life Chart feature with modular frontend and backend logic, fewer unnecessary API calls, and real-time slider updates.",
        "Unified login, signup, and verification flows across web and app by refactoring APIs, middleware, and cross-platform edge cases.",
        "Improved maintainability with lazy loading, better component structure, tests, and documentation for faster debugging.",
      ],
    },
    {
      title: "ML Intern",
      company: "IIT Indore",
      location: "Indore, India",
      period: "May 2022 - June 2022",
      bullets: [
        "Built a traffic sign recognition model on the GTSRB dataset using Python and TensorFlow for image classification.",
      ],
    },
  ],
  projects: [
    {
      title: "Real-Time Messaging Application",
      description:
        "A real-time chat platform with JWT authentication, WebSocket-based messaging, and persistent MongoDB-backed conversations.",
      tech: "MERN, Next.js, Socket.io, JWT",
      ghLink: "https://github.com/harshita-priya1/Bubble-Talk",
    },
    {
      title: "Soil Intelligence Assistant App",
      description:
        "An Android app that classifies soil from images, stores location-linked records, and answers soil-related queries in-app.",
      tech: "Flutter, Node.js, MongoDB, Python",
      ghLink: "https://github.com/harshita-priya1/the-soil-app-frontend",
    },
    {
      title: "This Portfolio Website",
      description:
        "A refreshed personal portfolio that presents current experience, selected projects, and the latest resume with reusable content sections.",
      tech: "React, Bootstrap, React Router",
      ghLink: "https://github.com/harshita-priya1/new-portfolio",
    },
  ],
  education: {
    institution: "Birla Institute of Technology, Mesra, Ranchi",
    period: "2019 - 2023",
    graduationYear: "2023",
    degree: "B.Tech, Civil Engineering",
    detail: "CGPA: 8.84/10",
  },
  achievements: [
    "Flipkart Grid 3.0: Reached Level 2 with an autonomous robotics solution using Arduino, OpenCV, Python, and ML.",
  ],
  personal: [
    "Sketching",
    "Badminton",
    "Travelling",
  ],
};
